/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { calTotal, getArticles, loadPaymentRequest } from "../../../store/Concept/actions";
import Table from "./components/Table";
import { Wrapper } from "./styled";
import { selectedItem } from "../../../store/Concept/actions";
import { articles, selectedArticles } from "../../../store/Concept/selectors";
import MainLayout from "../../commons/MainLayout";
import Header from "./components/Header";
import BackButton from "./components/BackButton";
import Button from "./components/GenerateCouponButton";
import { getContribData } from "../StartForm/components/Form/components/ContributorForm/components/ContributorInputs/constants";
import { getPayerData } from "../StartForm/components/Form/components/PayerForm/components/PayerInputs/constants";
import { contributorData, taxPayerData } from "../../../store/Users/selectors";
import { useHistory } from "react-router-dom";
import { isChecked } from "../../../utils/functions";
import { PATH_FORM } from "../App/constants";
import Alert from "../../commons/Alert";

const GenerateCoupon = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const items = useSelector(selectedArticles);
  const concepts = useSelector(articles);
  const dataContributor = useSelector(contributorData);
  const dataPayer = useSelector(taxPayerData);
  const contributor = getContribData(dataContributor);
  const payer = getPayerData(dataPayer);

  useEffect(() => {
    dispatch(loadPaymentRequest(null));
    if (isChecked(contributor, payer)) {
      history.push(PATH_FORM);
    }
    if (concepts.length === 0) {
      dispatch(getArticles());
    }
  }, []);

  useEffect(() => {
    dispatch(calTotal());
  }, [items]);

  return (
    <MainLayout>
      <Wrapper>
        <BackButton />
        <Header />
        <Alert />
        <Table addItem={selectedItem} />
        <Button />
      </Wrapper>
    </MainLayout>
  );
};

export default GenerateCoupon;
